import { combineReducers, configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import localforage from 'localforage';
import cidadesReducer from './slices/cidadesSlice';
import loginReducer from './slices/loginSlice';
import bairroTotemReducer from './slices/bairroTotemSlice';
import secretariasReducer from './slices/secretariasSlice';
import assuntoTotemReducer from './slices/assuntoTotemSlice';
import escolaridadeTotemReducer from './slices/escolaridadeTotemSlice';
import protocoloTotemReducer from './slices/protocoloTotemSlice';
import categoriaTotemReducer from './slices/categoriaTotemSlice';
import unidadeTotemReducer from './slices/unidadeTotemSlice';
import sexoTotemReducer from './slices/sexoTotemSlice';
import comoSoubeTotemReducer from './slices/comoSoubeTotemSlice';
import modalReducer from './slices/modalSlice';
import arquivosReducer from './slices/arquivosSlice';

const reducers = combineReducers({
  login: loginReducer,
  secretarias: secretariasReducer,
  cidades: cidadesReducer,
  modal: modalReducer,
  arquivos: arquivosReducer,
  bairroTotem: bairroTotemReducer,
  assuntoTotem: assuntoTotemReducer,
  unidadeTotem: unidadeTotemReducer,
  categoriaTotem: categoriaTotemReducer,
  protocoloTotem: protocoloTotemReducer,
  sexoTotem: sexoTotemReducer,
  escolaridadeTotem: escolaridadeTotemReducer,
  comoSoubeTotem: comoSoubeTotemReducer,
});

const persistConfig = {
  key: 'root',
  storage: localforage,
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
    },
  }),
});

export default store;
